import {useQuery} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {CustomReportDataType} from "../types/CustomReportDataType";

export const useGetCustomReportData = (companyId: number | undefined, reportType: string | undefined, layoutName: string, dateFrom: Date | undefined, dateTo: Date | undefined) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const {data, isLoading, refetch} = useQuery({
        queryKey: ['get-custom-report-data'],
        queryFn: async () => await apiClient.get('system-reports/custom-report-data', {
            params: {
                reportType,
                layoutName,
                dateFrom,
                dateTo
            }
        }) as CustomReportDataType,
        enabled: false,
        cacheTime: 0
    });

    return {
        data,
        isLoading,
        refetch
    };
};
